// ── 대시보드 모달 모음 ─────────────────────────────────────────────────────────
// 지각 사유 입력 모달 + 비밀번호 변경 모달
import React from 'react';
import Modal from '../../components/Modal';
import { Button } from '../../components/ui/Button';
import { Input, Textarea } from '../../components/ui/Input';
import { detailLineClass } from './styles';

/**
 * 대시보드 모달 모음
 *
 * Props:
 *   lateReasonModalOpen    — 지각 사유 모달 열림 여부
 *   latePromptInfo         — { schedule_start_time, late_minutes }
 *   actionLoading          — 처리 중 여부 (버튼 비활성화)
 *   lateReasonText         — 지각 사유 텍스트 값
 *   setLateReasonText      — 지각 사유 setter
 *   setLateReasonModalOpen — 모달 닫기 setter
 *   submitLateReasonCheckIn — 지각 사유 제출 후 출근 처리
 *   pwModal                — 비밀번호 변경 모달 열림 여부
 *   forcePwChange          — 강제 변경 여부 (true면 취소 불가)
 *   pwForm                 — { currentPassword, newPassword, confirmPassword }
 *   setPwForm              — pwForm setter
 *   changePassword         — 비밀번호 변경 처리 함수
 *   setPwModal             — 비밀번호 모달 닫기 setter
 */
export function DashboardModals({
  lateReasonModalOpen, latePromptInfo, actionLoading, lateReasonText,
  setLateReasonText, setLateReasonModalOpen, submitLateReasonCheckIn,
  pwModal, forcePwChange, pwForm, setPwForm, changePassword, setPwModal,
}) {
  return (
    <>
      {/* ── 지각 사유 입력 모달 ── */}
      <Modal
        open={lateReasonModalOpen}
        title="지각 사유 입력"
        icon="⏰"
        onClose={() => { if (actionLoading) return; setLateReasonModalOpen(false); }}
        footer={(
          <div className="flex justify-end gap-2">
            <Button
              variant="outline"
              disabled={actionLoading}
              onClick={() => setLateReasonModalOpen(false)}
            >
              취소
            </Button>
            <Button
              disabled={actionLoading}
              onClick={submitLateReasonCheckIn}
            >
              {actionLoading ? '처리 중...' : '출근 저장'}
            </Button>
          </div>
        )}
      >
        <div className="grid gap-3">
          {/* 기준 출근시간 / 지각 분 안내 */}
          <p className={detailLineClass}>
            {latePromptInfo.schedule_start_time
              ? `기준 출근시간: ${latePromptInfo.schedule_start_time}`
              : ''}
            {Number.isFinite(Number(latePromptInfo.late_minutes))
              ? ` / 지각 ${latePromptInfo.late_minutes}분`
              : ''}
          </p>
          <Textarea
            maxLength={500}
            placeholder="지각 사유를 입력해 주세요."
            value={lateReasonText}
            onChange={(e) => setLateReasonText(e.target.value)}
            className="min-h-24 resize-y"
          />
        </div>
      </Modal>

      {/* ── 비밀번호 변경 모달 ── */}
      <Modal
        open={pwModal}
        title="비밀번호 변경"
        icon="🔒"
        onClose={() => { if (!forcePwChange) setPwModal(false); }}
        footer={(
          <div className="flex justify-end gap-2">
            {!forcePwChange && (
              <Button variant="outline" onClick={() => setPwModal(false)}>취소</Button>
            )}
            <Button onClick={changePassword}>변경</Button>
          </div>
        )}
      >
        <div className="grid gap-2.5">
          <Input
            type="password"
            placeholder="현재 비밀번호"
            value={pwForm.currentPassword}
            onChange={(e) => setPwForm({ ...pwForm, currentPassword: e.target.value })}
          />
          <Input
            type="password"
            placeholder="새 비밀번호"
            value={pwForm.newPassword}
            onChange={(e) => setPwForm({ ...pwForm, newPassword: e.target.value })}
          />
          <Input
            type="password"
            placeholder="새 비밀번호 확인"
            value={pwForm.confirmPassword}
            onChange={(e) => setPwForm({ ...pwForm, confirmPassword: e.target.value })}
          />
          {/* 비밀번호 불일치 안내 */}
          {pwForm.newPassword && pwForm.confirmPassword
            && pwForm.newPassword !== pwForm.confirmPassword && (
            <p className="text-sm text-danger m-0">새 비밀번호 확인 값이 일치하지 않습니다.</p>
          )}
        </div>
      </Modal>
    </>
  );
}
